(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/start-bingo-game/assets/javascripts/start-bingo-game.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/start-bingo-game/assets/javascripts/start-bingo-game.js');
"use strict";


const {
  fetchAlias
} = svs.bingo_react.components.api;
const {
  BetterDialog
} = svs.components.lbUi.betterDialog;
const {
  canPlayOnVertical
} = svs.accountservices.player_exclusions;
const cmsGames = svs.bingo_react.data.cmsGames;
const bingoBaseUrl = svs.core.urlMapping.get('bingoHome2');
const aliasDialog = new BetterDialog().setIcon('exclamation-sign').setTitle('Alias').addText('För att spela Bingo behöver du sätta ett alias.').addAction('Sätt alias', () => {
  const url = "".concat(svs.core.urlMapping.get('myProfileHome'), "/uppgifter/alias?returnUrl=").concat(svs.utils.url.currentPathEncodedParams());
  svs.utils.url.navigate(url);
}).compose();
const startBingoGame = async (gameId, promoPosition) => {
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isLoggedIn) {
    svs.components.customer_login.login();
    return;
  }
  const alias = await fetchAlias();
  if (!alias) {
    aliasDialog.open();
  } else {
    const canPlay = await canPlayOnVertical('bingo');
    if (canPlay) {
      var _cmsGames$find;
      const gameName = (_cmsGames$find = cmsGames.find(cmsGame => cmsGame.id === gameId)) === null || _cmsGames$find === void 0 ? void 0 : _cmsGames$find.title;
      let qs = '';
      if (gameName) {
        const params = new URLSearchParams();
        params.set('gameName', gameName);
        qs = "?".concat(params);
      }
      if (promoPosition) {
        const evt = {
          id: bingoBaseUrl,
          name: "bingo-card-".concat(promoPosition),
          position: promoPosition
        };
        svs.components.analytics.trackPromoClick(evt);
      }
      svs.utils.url.navigate("".concat(bingoBaseUrl, "/spela/").concat(gameId).concat(qs));
    }
  }
};
setGlobal('svs.bingo_react.components.startBingoGame', startBingoGame);

 })(window);